"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tabs = void 0;
var react_1 = __importStar(require("react"));
var ternary_lint_util_1 = require("../../utils/ternary-utils/ternary-lint-util");
var styles_1 = require("./styles");
var Tabs = function (_a) {
    var tabs1Label = _a.tabs1Label, tabs1Children = _a.tabs1Children, tabs2Label = _a.tabs2Label, tabs2Children = _a.tabs2Children, tabs3Label = _a.tabs3Label, tabs3Children = _a.tabs3Children, tabs4Label = _a.tabs4Label, tabs4Children = _a.tabs4Children, isMobile = _a.isMobile, margin = _a.margin, onTabActiveChanged = _a.onTabActiveChanged, tabActive = _a.tabActive;
    var marginTabs = function (margin, isMobile) {
        if (margin) {
            return margin;
        }
        if (isMobile) {
            return '0 24px 40px';
        }
        return '0 0 40px 0';
    };
    var _b = (0, react_1.useState)(0), active = _b[0], setActive = _b[1];
    var handleClick = (0, react_1.useCallback)(function (tab) {
        if (tab !== active) {
            setActive(tab);
            onTabActiveChanged && onTabActiveChanged(tab);
        }
    }, [active, onTabActiveChanged]);
    (0, react_1.useEffect)(function () {
        if (tabActive !== undefined) {
            handleClick(tabActive);
        }
    }, [handleClick, tabActive]);
    return (react_1.default.createElement(styles_1.TabsSectionStyled, null,
        react_1.default.createElement(styles_1.TabsHeaderStyled, { "data-testid": "tab-header-list", role: "tablist", style: { margin: marginTabs(margin, isMobile) } },
            react_1.default.createElement(styles_1.TabsItensStyled, { role: "tab", id: "primeira-tab", "data-testid": "primeira-tab", "aria-selected": active === 0, onClick: function () { return handleClick(0); }, active: active === 0, className: active === 0 ? 'active' : '' }, tabs1Label),
            react_1.default.createElement(styles_1.TabsItensStyled, { role: "tab", id: "segunda-tab", "data-testid": "segunda-tab", "aria-selected": active === 1, onClick: function () { return handleClick(1); }, active: active === 1, className: active === 1 ? 'active' : '' }, tabs2Label),
            tabs3Label && (react_1.default.createElement(styles_1.TabsItensStyled, { role: "tab", id: "terceira-tab", "data-testid": "terceira-tab", "aria-selected": active === 2, onClick: function () { return handleClick(2); }, active: active === 2, className: (0, ternary_lint_util_1.retornaValorCondicionado)(active === 2, 'active', '') }, tabs3Label)),
            tabs4Label && (react_1.default.createElement(styles_1.TabsItensStyled, { role: "tab", id: "quarta-tab", "data-testid": "quarta-tab", "aria-selected": active === 3, onClick: function () { return handleClick(3); }, active: active === 3, className: (0, ternary_lint_util_1.retornaValorCondicionado)(active === 3, 'last active', 'last') }, tabs4Label))),
        react_1.default.createElement(styles_1.TabsContentStyled, { role: "tabpanel", "aria-labelledby": "primeira-tab", "data-testid": "conteudo-primeira-tab", active: active === 0 }, tabs1Children),
        react_1.default.createElement(styles_1.TabsContentStyled, { role: "tabpanel", "aria-labelledby": "segunda-tab", "data-testid": "conteudo-segunda-tab", active: active === 1 }, tabs2Children),
        tabs3Children && (react_1.default.createElement(styles_1.TabsContentStyled, { role: "tabpanel", "aria-labelledby": "terceira-tab", "data-testid": "conteudo-terceira-tab", active: active === 2 }, tabs3Children)),
        tabs4Children && (react_1.default.createElement(styles_1.TabsContentStyled, { role: "tabpanel", "aria-labelledby": "quarta-tab", "data-testid": "conteudo-quarta-tab", active: active === 3 }, tabs4Children))));
};
exports.Tabs = Tabs;
